import { render } from "./desc-item.vue?vue&type=template&id=a39be75a&scoped=true"
import script from "./desc-item.vue?vue&type=script&lang=js"
export * from "./desc-item.vue?vue&type=script&lang=js"

import "./desc-item.vue?vue&type=style&index=0&id=a39be75a&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39be75a"]])

export default __exports__